export default __webpack_public_path__ + "static/media/Arrow.58a9447d.svg";